import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ErrorHandlerService } from '@examdojo/core/error-handling';
import { mapToVoid } from '@examdojo/core/rxjs';
import { PayoutRequestService } from '@examdojo/payments';
import { EMPTY } from 'rxjs';

export const paymentRequestsResolver: ResolveFn<void> = () => {
  const payoutRequestService = inject(PayoutRequestService);
  const errorHandlerService = inject(ErrorHandlerService);

  return payoutRequestService.loadCurrentUserPayoutRequests().pipe(
    errorHandlerService.catchError('Error fetching payment requests', () => EMPTY, {
      toast: 'Error fetching payment requests',
    }),
    mapToVoid(),
  );
};
